import { IRadObject, Property, RadObject, RadObjectPropertyValues } from "../../../RadObject";
import { NAMESPACE } from "./_Namespace";

export type ClassPropertyValues =
    RadObjectPropertyValues
    & {
    };

export type ClassProperties = {
    [name in keyof ClassPropertyValues]: Property<ClassPropertyValues[name]>
};

export interface IClass extends IRadObject, ClassProperties
{
}

export class Class<TPropertyValues extends ClassPropertyValues = ClassPropertyValues> extends RadObject<TPropertyValues> implements IClass
{
    public static override classNamespace = NAMESPACE + "Class";
    public static override className = "Class";
}